import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormControl,
  Button,
  InputGroup,
  Modal,
  ProgressBar,
  Spinner
} from "react-bootstrap";

import CustomBackground from "../../components/UI/CustomBackground/CustomBackground";

import { useTranslation, Translation } from "react-i18next";

import { ReactComponent as InfoCircleLightIcon } from "../../assets/infoCircleLight.svg";

import graphQLClientInstance from "../../axios-graphql-client";

import axios from "axios";

import Bottleneck from "bottleneck";

import classes from "./SearchSpecies.module.css";

import CustomAsyncTypehead from "../../components/UI/CustomAsyncTypehead/CustomAsyncTypehead";
import CustomDropdown from "../../components/UI/CustomDropdown/CustomDropdown";
import Table, { tableOrigin } from "../../components/UI/Table/Table";
import MultiSelect from "react-multi-select-component";

import { Formik } from "formik";
import * as Yup from "yup";

import { withRouter } from "react-router-dom";

import Loader from "../../components/UI/Loader/Loader";

import {
  selectOptions,
  speciesCropSectorOptions,
  autoCompletePostData,
  searchVarietyReturnTypes,
  getSearchSpeciesQuery,
  commonNameLanguageOptions,
  searchSpeciesReturnTypes,
  scrollToRef,
  TABLE_SELECT_ROW,
  backgroundImages,
  overrideStrings,
  calcPercentage,
  calcRemaining,
  downloadBlob,
  renderTooltipOverlay,
  downloadExcelWorksheetTitles,
  downloadExcelFileNames,
  API_URLS
} from "../../shared/utility";

import { generatexlx } from "../../exportXls";
import SearchFormContainer from "../../components/UI/SearchFormContainer/SearchFormContainer";
import ResultsHeader from "../../components/UI/ResultsHeader/ResultsHeader";
import IndeterminateCheckbox from "../../components/UI/IndeterminateCheckbox/IndeterminateCheckbox";
import { useMatomo } from '@datapunt/matomo-tracker-react';

const SearchSpecies = (props: any) => {
  const { trackPageView } = useMatomo()

  React.useEffect(() => {
    trackPageView({documentTitle:'Search Species'})
    // eslint-disable-next-line
  }, [])

  const { t, i18n } = useTranslation();

  const {
    modal,
    selectedSpeciesData
  } = props;

  const modalRef = React.useRef(false);
  modalRef.current = modal;

  const resultsRef = React.useRef(null);

  const [formValues, setFormValues] = useState([]);

  const [data, setData] = useState([]);
  const [pageCount, setPageCount] = useState(0);

  const [totalCount, setTotalCount] = useState(0);
  const totalCountRef = React.useRef(0);
  totalCountRef.current = totalCount;

  const [pageIndex, setPageIndex] = useState(0);

  const [completedPromises, setCompletedPromises] = useState<number>(0);

  const [generateExcel, setGenerateExcel] = useState(false);
  const generateExcelRef = React.useRef(false);
  generateExcelRef.current = generateExcel;

  const [isLoading, setIsLoading] = useState(false);

  const [displayResults, setDisplayResults] = useState(false);

  const [excelModalShow, setExcelModalShow] = useState(false);

  const handleExcelModalClose = () => setExcelModalShow(false);
  const handleExcelModalShow = () => setExcelModalShow(true);

  const fetchData = React.useCallback(
    ({ pageSize: tablePageSize, pageIndex: tablePageIndex, values }) => {
      setData([]);
      setPageIndex(tablePageIndex);
      setIsLoading(true);

      if (tablePageIndex === 0) {
        setPageCount(0);
        setTotalCount(0);
      }

      graphQLClientInstance
        .post(
          API_URLS.GRAPHQL,
          getSearchSpeciesQuery(values, tablePageSize, tablePageIndex)
        )
        .then((res) => {
          if (
            res.data?.data?.speciesSearch?.total
          ) {
            setTotalCount(res.data.data.speciesSearch.total);
            setPageCount(
              Math.ceil(res.data.data.speciesSearch.total / tablePageSize)
            );
          }

          if (res.data?.data?.speciesSearch?.data) {
            setData(res.data.data.speciesSearch.data);
          }
          setIsLoading(false);
          setDisplayResults(true);
          scrollToRef(resultsRef);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log(err);
        });
    },
    []
  );

  const selectedData = React.useCallback(({ data: selectedData }) => {
    if (modalRef.current) {
      selectedSpeciesData({ selectedSpecies: selectedData });
    }
  }, [selectedSpeciesData]);

  const limiter = new Bottleneck({
    minTime: 200,
    maxConcurrent: 3,
  });

  const completedPromisesRef = React.useRef(completedPromises);

  const generatePromises = async (values: any, totalItems: number) => {
    completedPromisesRef.current = 0;
    let i = 0;
    let pageIdx = 0;
    const promiseArray: Array<Promise<any>> = [];
    while (i < totalItems) {
      const body = getSearchSpeciesQuery(values, 1000, pageIdx);
      const promise = limiter.schedule(() =>
        graphQLClientInstance.post(API_URLS.GRAPHQL, body)
      );
      promiseArray.push(promise);
      i += 1000;
      pageIdx++;
    }

    let dataArr: Array<any> = [];
    await axios.all(promiseArray).then(
      axios.spread((...res) => {
        dataArr = res.map((r) => r.data.data.speciesSearch.data);
      })
    );
    return dataArr;
  };

  const completedPromisesCounter = (count: number) => {
    completedPromisesRef.current = count;
    setCompletedPromises(count);
  };

  // state to keep track of resolved promises
  limiter.on("done", function (info) {
    completedPromisesCounter(completedPromisesRef.current + 1);
  });

  const downloadExcelFile = async ({ values }: { values: any }) => {
    setGenerateExcel(false);
    let myData: any[] = [];
    await generatePromises(values, totalCountRef.current)
      .then((res) => {
        if (res) {
          myData = res;
        }
      })
      .catch((err) => {
        console.log(err);
      });

    const flattenData: any[] = myData.flat(2)
    .map((dataRow: any[]) => {
      //@ts-ignore
      return {...dataRow, class_data: dataRow?.class_data?.map(classItem => classItem.class_id)}
    });
    let file = "";
    setGenerateExcel(true);
    file = await generatexlx(
      flattenData,
      [
        searchSpeciesReturnTypes.SPECIES_CODE,
        searchSpeciesReturnTypes.SPECIES_CLASS,
        searchSpeciesReturnTypes.PRINCIPAL_BOTANICAL_NAME,
        searchSpeciesReturnTypes.OTHER_BOTANICAL_NAMES,
        searchSpeciesReturnTypes.COMMON_NAME_EN,
        searchSpeciesReturnTypes.COMMON_NAME_FR,
        searchSpeciesReturnTypes.COMMON_NAME_DE,
        searchSpeciesReturnTypes.COMMON_NAME_ES,
        searchSpeciesReturnTypes.CROP_SECTOR,
      ],
      downloadExcelWorksheetTitles.SEARCH_SPECIES_WORKSHEET
    ).catch((err) => {
      console.log(err);
    });

    if (file) {
      const blob = new Blob([file], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      downloadBlob(blob, downloadExcelFileNames.SEARCH_SPECIES);
    }
    setExcelModalShow(false);
  };

  useEffect(() => {
    if (completedPromises) {
      handleExcelModalShow();
    }
  }, [completedPromises]);

  const downloadExcel = React.useCallback(
    ({ values }) => {
      downloadExcelFile({ values: values });
    }, []
  );

  const speciesSelectOptions = () => {
    return [
      { value: t(selectOptions.STARTS), key: selectOptions.STARTS },
      { value: t(selectOptions.EXACT), key: selectOptions.EXACT },
      {
        value: t(selectOptions.CONTAINS),
        key: selectOptions.CONTAINS,
        default: true,
      },
    ];
  };

  const selectedColumns = [
    {
      name: searchSpeciesReturnTypes.SPECIES_CODE,
      label: <Translation>{(translate) => translate("species_code")}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 0,
    },
    {
      name: searchSpeciesReturnTypes.SPECIES_CLASS,
      label: <Translation>{(translate) => translate("class")}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 2,
    },
    {
      name: searchSpeciesReturnTypes.PRINCIPAL_BOTANICAL_NAME,
      label: <Translation>{(translate) => translate("principal_botanical_name")}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 3,
    },
    {
      name: searchSpeciesReturnTypes.OTHER_BOTANICAL_NAMES,
      label: <Translation>{(translate) => translate("other_botanical_names")}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 4,
      extraFieldData: searchVarietyReturnTypes.SPECIES_CLASS_NAME,
    },
    {
      name: searchSpeciesReturnTypes.COMMON_NAME_EN,
      label: <Translation>{(translate) => translate("common_name")}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 5,
    },
    {
      name: searchSpeciesReturnTypes.CROP_SECTOR,
      label: <Translation>{(translate) => translate("crop_sector")}</Translation>,
      enabled: true,
      isDefault: true,
      defaultOrder: 6,
    },
  ];

  const initialValues: { [key: string]: any } = {
    speciesLatinNameSelect: selectOptions.CONTAINS,
    speciesLatinName: [],
    speciesCodeSelect: selectOptions.CONTAINS,
    speciesCode: [],
    commonNameSelect: selectOptions.CONTAINS,
    commonName: [],
    commonNameLanguage: [],
    speciesCropSector: [],
  };

  const form = (
    <Formik
      initialValues={initialValues}
      validationSchema={Yup.object().shape({})}
      onSubmit={(values: any, { setFieldValue, setSubmitting }) => {
        const payload = {
          ...values,
        };
        setPageIndex(0);
        setFormValues(payload);
        setSubmitting(false);
        setIsLoading(true);
        setDisplayResults(true);
      }}
    >
      {(formProps) => (
        <Form
          className={classes.searchForm}
          onSubmit={(e) => {
            formProps.handleSubmit();
            e.preventDefault();
          }}
        >
          {props.modal?(
          <Row className={classes.header}>
            <Col md="12">
              {t("select_species")}
            </Col>
          </Row>
          ):<></>}
          <Row className={classes.searchFieldsRow}>
            <Col md="8" id="speciesLatinNameContainer">
              <Form.Group controlId="searchForm.speciesLatinName">
                <Form.Label className="w-100">
                  {t("species_latin_name")}
                  {renderTooltipOverlay(
                    t("tooltips_species.species_latin_name"),
                    <InfoCircleLightIcon />
                  )}
                </Form.Label>
                <InputGroup className="mb-3">
                  <CustomDropdown
                    name="speciesLatinNameSelect"
                    label="SpeciesLatinNameSelect"
                    as={InputGroup.Prepend}
                    id="dropdown-species-latin-name"
                    value={formProps.values.speciesLatinNameSelect}
                    options={speciesSelectOptions()}
                    setFieldValue={formProps.setFieldValue}
                  />
                  <CustomAsyncTypehead
                    allowNew
                    useCache={false}
                    selected={formProps.values.speciesLatinName}
                    newSelectionPrefix={t("typeahead_new_selection")}
                    name="speciesLatinName"
                    id="speciesLatinNameTypeahead"
                    label={t("species_latin_name")}
                    postUrl={API_URLS.GRAPHQL}
                    postData={autoCompletePostData}
                    selectFieldValue={formProps.values.speciesLatinNameSelect}
                    autoCompleteName="autoCompleteSpeciesLatinName"
                    autoCompleteReturnString="{ name principal }"
                    setFieldValue={formProps.setFieldValue}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md="4" id="speciesCodeContainer">
              <Form.Group controlId="searchForm.speciesCode">
                <Form.Label className="w-100">
                  {t("species_code")}
                  {renderTooltipOverlay(
                    t("tooltips_species.species_code"),
                    <InfoCircleLightIcon />
                  )}
                </Form.Label>
                <InputGroup className="mb-3">
                  <CustomDropdown
                    name="speciesCodeSelect"
                    label="speciesCodeSelect"
                    as={InputGroup.Prepend}
                    id="dropdown-species-code"
                    options={speciesSelectOptions()}
                    value={formProps.values.speciesCodeSelect}
                    setFieldValue={formProps.setFieldValue}
                  />
                  <FormControl
                    name="speciesCode"
                    as="input"
                    type="text"
                    value={formProps.values.speciesCode}
                    onChange={formProps.handleChange}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md="8" id="commonNameContainer">
              <Form.Group controlId="searchForm.commonName">
                <Form.Label className="w-100">
                  {t("common_name")}
                  {renderTooltipOverlay(
                    t("tooltips_species.common_name"),
                    <InfoCircleLightIcon />
                  )}
                </Form.Label>
                <InputGroup className="mb-3">
                  <CustomDropdown
                    name="commonNameSelect"
                    label="commonNameSelect"
                    as={InputGroup.Prepend}
                    id="dropdown-common-name"
                    options={speciesSelectOptions()}
                    value={formProps.values.commonNameSelect}
                    setFieldValue={formProps.setFieldValue}
                  />
                  <FormControl
                    name="commonName"
                    as="input"
                    type="text"
                    value={formProps.values.commonName}
                    onChange={formProps.handleChange}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md="4" id="commonNameLanguageContainer">
              <Form.Group controlId="searchForm.commonNameLanguage">
                <Form.Label className="w-100">
                  {t("common_name_language")}
                  {renderTooltipOverlay(
                    t("tooltips_species.common_name_language"),
                    <InfoCircleLightIcon />
                  )}
                </Form.Label>
                <MultiSelect
                  onChange={(val: any) =>
                    formProps.setFieldValue("commonNameLanguage", val)
                  }
                  value={formProps.values.commonNameLanguage}
                  className="customMultiSelect"
                  options={commonNameLanguageOptions()}
                  disableSearch={true}
                  disabled={formProps.values.commonName.length === 0}
                  overrideStrings={overrideStrings()}
                  labelledBy="commonNameLanguage"
                />
              </Form.Group>
            </Col>
            <Col md="4" id="speciesCropSectorContainer">
              <Form.Group controlId="searchForm.speciesCropSector">
                <Form.Label className="w-100">
                  {t("species_crop_sector")}
                  {renderTooltipOverlay(
                    t("tooltips_species.species_crop_sector"),
                    <InfoCircleLightIcon />
                  )}
                </Form.Label>
                <MultiSelect
                  onChange={(val: any) =>
                    formProps.setFieldValue("speciesCropSector", val)
                  }
                  value={formProps.values.speciesCropSector}
                  className="customMultiSelect"
                  options={speciesCropSectorOptions()}
                  disableSearch={true}
                  overrideStrings={overrideStrings()}
                  labelledBy="speciesCropSector"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className={classes.actionsRow}>
            <Col md="12">
              <Button
                id="submitSearchForm"
                variant="primary"
                type="submit"
                disabled={formProps.isSubmitting}
                className="float-right"
              >
                {t("search")}
              </Button>
              <Button
                id="clearFields"
                variant="link"
                onClick={() => {
                  formProps.resetForm();
                }}
                className="float-right mr-2"
              >
                {t("clear_fields")}
              </Button>
              <Button
                id="help"
                variant="link"
                onClick={() => window.open(`help/${i18n.language}/Species.html`, '_blank')}
                className="float-right mr-2">
                  {t("help")}
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );

  const tableColumns = React.useMemo(() => {
    const firstColumn = modalRef.current
      ? [
          {
            id: TABLE_SELECT_ROW,
            Header: ({
              getToggleAllRowsSelectedProps,
            }: {
              getToggleAllRowsSelectedProps: any;
            }) => (
              <div>
                <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
              </div>
            ),
            Cell: ({ row }: { row: any }) => (
              <div>
                <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
              </div>
            ),
          },
        ]
      : [];
    return [
      ...firstColumn,
      ...selectedColumns
        .filter((col: any) => col.id !== TABLE_SELECT_ROW)
        .map((item: any) => {
          return { ...item, Header: item.label, accessor: item.name };
        }),
    ];
  }, [selectedColumns]);

  const downloadExcelModal = (
    <Modal
      centered
      keyboard={false}
      backdrop="static"
      show={excelModalShow}
      onHide={handleExcelModalClose}
    >
      <Modal.Header>
        <Modal.Title>{t("downloading_results")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ProgressBar
          className="w-100"
          now={calcPercentage(completedPromises, totalCount / 1000)}
          label={`${calcPercentage(completedPromises, totalCount / 1000)}%`}
        />
        <br></br>
        <div>
          {t("results_downloaded_counter", {
            current: calcRemaining(completedPromises * 1000, totalCount),
            total: totalCount,
          })}
        </div>
        <div>
          {generateExcel?
            <>
              {t("generate_excel")} <Spinner animation="border" size="sm" variant="primary" />
            </>
          :""}
        </div>
      </Modal.Body>
    </Modal>
  );

  const searchContainer = (
    <CustomBackground image={backgroundImages.SPECIES}>
      <SearchFormContainer
        title={t("search_species.title")}
        subtitle={t("search_species.subtitle")}
      >
        {form}
      </SearchFormContainer>
    </CustomBackground>
  );

  return (
    <>
      <Loader show={isLoading}></Loader>
      {props.modal ? form : searchContainer}
      {displayResults ? (
        <Container
          fluid
          style={{
            display: !(isLoading && totalCount === 0) ? "block" : "none",
          }}
          className={classes.resultsTable}
        >
          <ResultsHeader totalCount={totalCount} resultsRef={resultsRef} />
          <Table
            columns={tableColumns}
            origin={tableOrigin.SEARCH_SPECIES}
            hideColumnsButton={true}
            modal={props.modal}
            isSortable={false}
            selectedData={selectedData}
            data={data}
            fetchData={fetchData}
            downloadExcel={downloadExcel}
            pageCount={pageCount}
            totalCount={totalCount}
            pageIndex={pageIndex}
            formValues={formValues}
            showPagination={true}
            pageSizeOptions={[5, 10, 20, 25, 50, 100]}
          />
          {downloadExcelModal}
        </Container>
      ) : (
        <></>
      )}
    </>
  );
};

export default withRouter(SearchSpecies);
